// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1037":"29b4390e","3048":"89a8d732","3068":"89a8d732","5531":"89a8d732","5830":"96d310ab"}[chunkId] + ".chunk.css";
};